/*
 * @Author: tianshuai 1446360207@qq.com
 * @Date: 2024-08-05 15:25:27
 * @LastEditors: tianshuai 1446360207@qq.com
 * @LastEditTime: 2024-10-16 14:44:57
 * @FilePath: \惠宾官网\src\assets\http\http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
const request = axios.create({
  baseURL: "", // 接口基础路径
  timeout: 10000, // 请求超时时间，默认10秒
  headers:{
    'Content-Type': 'application/json, text/plain, */*'
  }
})
// 请求拦截器
request.interceptors.request.use(config => {
    // console.log('在请求发送之前做一些处理:',config);
    // 在请求发送之前做一些处理
    return config
  },
  error => {
    // 对请求错误做处理
    // console.log('对请求错误做处理:',error);
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(response => {
    // 对响应数据做处理
    // console.log('对响应数据做处理:',response);
    return response
  },
  error => {
    // 对响应错误做处理
    // console.log('对响应错误做处理:',error);
    return Promise.reject(error)
  }
)

export default request